<template>
  <header class="header">
    <Logo class="header__logo" />
    <div v-if="isAppLoading" class="header__avatar">
      <vue-loaders name="ball-scale-multiple" color="#ef7d22" />
    </div>
    <div v-else>
      <div v-if="showSignOutLink">
        <div v-if="userProfile.email" class="header__avatar">
          <a :href="`//${logoutUrl}`" class="header__cta">
            Not {{ name }}? <br />
            Sign out
          </a>
          <img :src="avatar" class="header__avatar--img" />
        </div>
      </div>
      <div v-else class="header__actions">
        <router-link
          :to="{ name: 'shop' }"
          :class="[
            'btn btn--secondary',
            !isAuthenticated && 'header__cta',
            isAuthenticated && 'header__signin-btn',
          ]"
          >See all plans</router-link
        >
      </div>
      <div v-if="isSkillDivePreSalePage" class="header__actions">
        <router-link :to="{ name: 'shop' }" class="btn btn--secondary header__cta">
          Back to shop
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Logo from '@/assets/icons/ine-logo.svg'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'TheHeader',
  mixins: [routesRules],
  components: {
    Logo: { ...Logo, name: 'Logo' },
  },
  data() {
    return {
      logoRoutes: ['shop', 'trial', 'register', 'complete', 'registration-complete'],
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      isAppLoading: state => state.app.isAppLoading,
      customCoupon: state => state.shoppingCart.coupon,
      promotionalField: state => state.subscriptions.promotionalField,
      isNewAccountModalShown: state => state.app.isNewAccountModalShown,
      userProfile: state => state.auth.userProfile,
    }),
    ...mapGetters({
      selectedPlan: 'shoppingCart/selectedPlan',
    }),
    avatar() {
      const { avatar } = this.userProfile
      return avatar
    },
    name() {
      const { first_name, last_name } = this.userProfile
      return `${first_name} ${last_name}`
    },
    logoutUrl() {
      return `${process.env.VUE_APP_STREAMING_URL}/logout?redirect_url=https://${this.redirectUrl}`
    },
    streamingLink() {
      return `${process.env.VUE_APP_STREAMING_URL}`
    },
    redirectUrl() {
      return process.env.VUE_APP_REDIRECT_URL
    },
  },
  methods: {
    ...mapMutations({
      setIsNewAccountModalShown: 'app/IS_NEW_ACCOUNT_MODAL_SHOWN_UPDATED',
    }),
    buildRedirectUrl() {
      const {
        customCoupon: coupon,
        redirectUrl,
        selectedPlan: { merchant_id },
        streamingLink,
        promotionalField,
      } = this
      const arrParams = []
      let redirect = `https://${redirectUrl}`

      if (merchant_id && merchant_id.length) {
        arrParams.push(`plan=${merchant_id}`)
      }
      if (coupon && coupon.length) {
        arrParams.push(`coupon=${coupon}`)
      }
      if (promotionalField && promotionalField.length) {
        arrParams.push(`special_offer=${promotionalField}`)
      }

      if (arrParams.length) {
        redirect += `?${arrParams.join('&')}`
      }

      const encodedUrl = encodeURIComponent(redirect)
      window.location.assign(`https://${streamingLink}/login?redirect_url=${encodedUrl}`)
    },
    handleSignupClick() {
      this.$router.push({ name: 'account' })
    },
  },
}
</script>

<style lang="scss">
.header {
  width: 100%;
  height: 50px;
  z-index: 3;
  position: relative;
  top: 0;
  display: flex;
  align-items: center;
  background: var(--charcoal-gradient);
  padding: 0 15px;
  @include tablet {
    height: 88px;
    padding: 20px 50px;
  }
  &__logo {
    height: 100%;
    width: 85px;
  }
  &__avatar {
    position: absolute;
    right: 10px;
    background: transparent;
    border: none;
    top: 10px;
    display: flex;
    align-items: center;
    &--img {
      height: 50px;
      width: 50px;
      border-radius: 50%;
    }
    @include tablet {
      right: 40px;
    }
  }
  &__cta {
    font-family: var(--font-regular);
    color: var(--white);
    font-size: rem(14px) !important;
    line-height: 20px;
    margin: 0 15px 0 0;
    text-align: right;
    text-decoration: none;
    cursor: pointer;
    height: 36px !important;
  }
  &__actions {
    position: absolute;
    right: 10px;
    top: 15px;
    display: flex;
    align-items: center;
    @include tablet {
      right: 40px;
    }
  }
}
</style>
